module.exports = __webpack_public_path__ + "img/icon1.6381de53.png";